import React from 'react';
import { useTranslation } from 'react-i18next';
import { AudioOptionsButton } from '../AudioControls';
import {
  CamOnIcon,
  CamOffIcon,
  ShareIcon,
  PipIcon,
  MoreIcon,
  LeaveIcon,
} from '../MeetingIcons';
import DeviceMenuList from '../DeviceMenuList';
import {
  deviceMenuStyle,
  deviceMenuItemStyle,
} from '../../styles/deviceMenuStyles';

const MeetingDock = ({
  meetingPayload,
  initialAudioOutputDeviceId,
  onAudioInputSelected,
  onAudioOutputSelected,
  localCameraOn,
  cameraBusy,
  handleCameraToggle,
  openCameraMenu,
  showCameraMenu,
  cameraDevices,
  activeCameraDeviceId,
  handleChooseCameraDevice,
  isLocalUserSharing,
  handleContentShareToggle,
  isLocalShareLoading,
  pipMenuRef,
  cameraMenuRef,
  pipMode,
  handlePiPToggle,
  pipToggleDisabled,
  onLeave,
  showParticipants,
  toggleParticipants,
}) => {
  const { t } = useTranslation();

  return (
  <div className="meeting-dock">
    <div className="dock-left">
      <span className="meeting-title">Novotalk 1:1</span>
    </div>
    <div className="dock-center">
      <AudioOptionsButton
        initialAudioOutputDeviceId={initialAudioOutputDeviceId}
        onAudioInputSelected={onAudioInputSelected}
        onAudioOutputSelected={onAudioOutputSelected}
      />
      <div className="pip-menu-wrap" ref={cameraMenuRef}>
        <button
          type="button"
          className={`meeting-action-btn ${!localCameraOn ? 'off' : ''}`}
          onClick={handleCameraToggle}
          disabled={cameraBusy}
          data-tooltip={localCameraOn ? t('VideoChatV2.camera.turnOff') : t('VideoChatV2.camera.turnOn')}
          aria-label={localCameraOn ? t('VideoChatV2.camera.turnOff') : t('VideoChatV2.camera.turnOn')}
        >
          {localCameraOn ? <CamOnIcon /> : <CamOffIcon />}
        </button>
        <button
          type="button"
          className="pip-mode-more"
          onClick={openCameraMenu}
          data-tooltip={t('VideoChatV2.camera.choose')}
          aria-label={t('VideoChatV2.camera.choose')}
        >
          <MoreIcon />
        </button>
        {showCameraMenu ? (
          <DeviceMenuList
            devices={cameraDevices}
            activeDeviceId={activeCameraDeviceId}
            onSelect={handleChooseCameraDevice}
            menuAriaLabel={t('VideoChatV2.camera.label')}
            menuStyle={deviceMenuStyle}
            getItemStyle={(active) => deviceMenuItemStyle(active)}
          />
        ) : null}
      </div>
      <button
        type="button"
        className={`meeting-action-btn ${isLocalUserSharing ? 'active' : ''}`}
        onClick={handleContentShareToggle}
        disabled={isLocalShareLoading}
        data-tooltip={isLocalUserSharing ? t('VideoChatV2.share.stop') : t('VideoChatV2.share.start')}
        aria-label={isLocalUserSharing ? t('VideoChatV2.share.stop') : t('VideoChatV2.share.start')}
      >
        <ShareIcon />
      </button>
      <div className="pip-menu-wrap" ref={pipMenuRef}>
        <button
          type="button"
          className={`meeting-action-btn ${pipMode ? 'active' : ''}`}
          onClick={handlePiPToggle}
          disabled={pipToggleDisabled}
          data-tooltip={t('VideoChatV2.pip.label')}
          aria-label={t('VideoChatV2.pip.label')}
        >
          <PipIcon />
        </button>
      </div>
      <button
        type="button"
        className="meeting-action-btn leave"
        onClick={onLeave}
        data-tooltip={t('VideoChatV2.leaveMeeting')}
        aria-label={t('VideoChatV2.leaveMeeting')}
      >
        <LeaveIcon />
      </button>
    </div>
    <div className="dock-right">
      <button
        type="button"
        className={`dock-icon-btn ${showParticipants ? 'active' : ''}`}
        data-tooltip={t('Common.UI.participants')}
        aria-label={t('Common.UI.participants')}
        onClick={toggleParticipants}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.98 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
        </svg>
      </button>
    </div>
  </div>
  );
};

export default React.memo(MeetingDock);
